import { OperationStatusLabel } from '@/context/services/invoice/type';
import {
  CheckboxGroupProps,
  SelectProps,
} from '@moneyforward/ap-frontend-components';
import { useMemo } from 'react';

export type ReceivedInvoiceOperationStatusOptions = {
  selectOptions: SelectProps['options'];
  checkboxOptions: CheckboxGroupProps['options'];
};

export const useReceivedInvoiceOperationStatusOptions =
  (): ReceivedInvoiceOperationStatusOptions => {
    const selectOptions = useMemo(
      () => [
        {
          value: 'ocr_processing',
          label: OperationStatusLabel.ocr_processing || '',
        },
        { value: 'not_started', label: OperationStatusLabel.not_started || '' },
        { value: 'applying', label: OperationStatusLabel.applying || '' },
        { value: 'applied', label: OperationStatusLabel.applied || '' },
        { value: 'archived', label: OperationStatusLabel.archived || '' },
      ],
      []
    );

    const checkboxOptions = useMemo(
      () => [
        {
          value: 'not_started',
          label: OperationStatusLabel.not_started || '',
          testId: 'invoice-search-operation-status-not_started',
        },
        {
          value: 'applying',
          label: OperationStatusLabel.applying || '',
          testId: 'invoice-search-operation-status-applying',
        },
        {
          value: 'applied',
          label: OperationStatusLabel.applied || '',
          testId: 'invoice-search-operation-status-applied',
        },
        {
          value: 'archived',
          label: OperationStatusLabel.archived || '',
          testId: 'invoice-search-operation-status-archived',
        },
      ],
      []
    );

    return { selectOptions, checkboxOptions };
  };
